import { render, staticRenderFns } from "./SendGroupList.vue?vue&type=template&id=cd790b34"
import script from "./SendGroupList.vue?vue&type=script&lang=js"
export * from "./SendGroupList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports